export const PERMIT2_ALLOWANCE_ADDRESS = import.meta.env.VITE_PERMIT2_ADDRESS
  || '0x000000000022D473030F116dDEE9F6B43aC78BA3';

export const PERMIT2_ALLOWANCE_SETTLEMENT_ADDRESS = import.meta.env.VITE_PERMIT2_ALLOWANCE_SETTLEMENT_ADDRESS
  || '0xcCa0dDa5Db0F77B71E5408405EC86EdE33384Ece';

export const PERMIT2_APPROVAL_EXPIRATION_SECONDS = 30 * 24 * 60 * 60;
export const MAX_UINT160 = (1n << 160n) - 1n;

export function getPermit2ApprovalExpiration(
  nowSeconds = BigInt(Math.floor(Date.now() / 1000)),
): bigint {
  return nowSeconds + BigInt(PERMIT2_APPROVAL_EXPIRATION_SECONDS);
}
